module.exports = __webpack_public_path__ + "img/entity_01.6aa3ffd6.jpg";